// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CreateProfile.css */

.cp-auth-container {
  --bg: #000000;
  --panel: #0a0a0a;
  --border: darkslategray;
  --text: #ffffff;
  --muted: rgba(255, 255, 255, 0.55);
  --faint: rgba(255, 255, 255, 0.35);
  --accent: #4fd1c5;
  --danger: #e06a6a;
  --field: rgba(255, 255, 255, 0.04);

  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  padding: 40px 20px 64px;
  background: var(--bg);
  color: var(--text);
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* ── panel ─────────────────────────────────────────────── */

.pc-form-container {
  width: 100%;
  max-width: 640px;
  padding: 32px;
  border: 1px solid var(--border);
  border-radius: 20px;
}

.form-box-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 20px;
  margin-bottom: 26px;
}

.pc-form-container h2 {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text);
  text-align: left;
}

.form-box-header .logo-default-container-img {
  width: 46px;
  height: 46px;
  object-fit: contain;
  flex-shrink: 0;
}

/* ── form layout ───────────────────────────────────────── */

.pc-form-container form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* one row = one or more fields side by side */
.pc-form-group-row {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  width: 100%;
}

.pc-form-group {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pc-form-group label {
  font-size: 13px;
  font-weight: 600;
  color: var(--muted);
  text-align: left;
}

.pc-form-group label .pc-req { color: var(--accent); }

.pc-hint {
  font-size: 11px;
  color: var(--faint);
  line-height: 1.5;
}

/* ── fields ────────────────────────────────────────────── */

.cp-auth-container input[type="text"],
.cp-auth-container input[type="tel"],
.cp-auth-container input[type="date"],
.cp-auth-container input[type="password"],
.cp-auth-container select,
.cp-auth-container textarea {
  width: 100%;
  height: 46px;
  padding: 0 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--field);
  color: var(--text);
  font-size: 14px;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.18s ease;
}

.cp-auth-container input::placeholder { color: var(--faint); }

.cp-auth-container input:focus,
.cp-auth-container select:focus { border-color: var(--accent); }

.cp-auth-container input:disabled,
.cp-auth-container input[readonly] {
  color: var(--muted);
  background: rgba(255, 255, 255, 0.02);
}

.cp-auth-container input[type="date"] { color-scheme: dark; }

/* ── checkbox rows ─────────────────────────────────────── */

.pc-checkbox-container,
.terms-conditions {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 10px;
}

.pc-checkbox-container label,
.terms-conditions label {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: var(--text);
  cursor: pointer;
}

.cp-auth-container input[type="checkbox"] {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  margin: 0;
  accent-color: var(--accent);
  cursor: pointer;
}

/* ── upload rows ───────────────────────────────────────── */

.pc-upload-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.pc-profilepic,
.pc-mediaupload {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 46px;
  padding: 0 6px 0 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--field);
  box-sizing: border-box;
}

.pc-uploadimage,
.pc-mediaupload input[type="text"] {
  flex: 1 1;
  min-width: 0;
  height: auto !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  font-size: 14px;
}

.pc-imageupload {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid var(--border);
  cursor: pointer;
  transition: border-color 0.18s ease;
}

.pc-imageupload:hover { border-color: var(--accent); }

.pc-upload-icon { color: var(--muted); font-size: 15px; }

/* ── buttons ───────────────────────────────────────────── */

.pc-btn {
  height: 46px;
  padding: 0 20px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: rgb(34, 31, 31);
  color: var(--text);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.18s ease;
}

.pc-btn:hover:not(:disabled) { border-color: var(--accent); }

.pc-btn-accent {
  border-color: var(--accent);
  background: var(--accent);
  color: #000;
}

.submit-btn {
  width: 100%;
  height: 50px;
  margin-top: 6px;
  border-radius: 10px;
  border: 1px solid var(--accent);
  background: var(--accent);
  color: #000;
  font-size: 15px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.18s ease;
}

.submit-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  background: rgb(34, 31, 31);
  border-color: var(--border);
  color: var(--muted);
}

/* ── messages ──────────────────────────────────────────── */

.error-message {
  margin: 0 0 18px;
  padding: 11px 14px;
  border: 1px solid rgba(224, 106, 106, 0.4);
  border-radius: 10px;
  background: rgba(224, 106, 106, 0.08);
  color: var(--danger);
  font-size: 13px;
  text-align: left;
}

/* ── links + footer ────────────────────────────────────── */

.cp-auth-container a { color: var(--accent); text-decoration: none; }
.cp-auth-container a:hover { text-decoration: underline; }

.copyright-container {
  margin-top: 8px;
  padding-top: 20px;
  border-top: 1px solid var(--border);
}

.copyright {
  margin: 0;
  font-size: 11px;
  line-height: 1.6;
  color: var(--faint);
  text-align: center;
}

/* ── responsive ────────────────────────────────────────── */

@media (max-width: 620px) {
  .cp-auth-container { padding: 22px 14px 48px; }
  .pc-form-container { padding: 22px; }
  .pc-form-container h2 { font-size: 21px; }
  .pc-form-group-row,
  .pc-upload-row { flex-direction: column; align-items: stretch; }
  .pc-btn { width: 100%; }
}

/* ── two-box picker ────────────────────────────────────── */

.cp-picker {
  display: flex;
  align-items: stretch;
  gap: 12px;
}

.cp-box {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--field);
  overflow: hidden;
}

.cp-box-drop { border-style: dashed; }

.cp-box-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 11px 14px;
  border-bottom: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.03);
}

.cp-box-head h4 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
}

.cp-box-count {
  font-size: 11px;
  font-weight: 600;
  color: var(--muted);
  padding: 2px 9px;
  border: 1px solid var(--border);
  border-radius: 999px;
}

.cp-box-count.is-full { color: var(--accent); border-color: var(--accent); }

.cp-box-body {
  flex: 1 1;
  min-height: 230px;
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.cp-box-empty {
  margin: auto;
  font-size: 12px;
  color: var(--faint);
  text-align: center;
}

.cp-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: rgb(34, 31, 31);
  color: var(--text);
  font-size: 13px;
  text-transform: capitalize;
  cursor: grab;
  transition: border-color 0.16s ease;
}

.cp-item:hover { border-color: var(--accent); }

.cp-item.is-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.cp-item.is-disabled:hover { border-color: var(--border); }

.cp-item-selected { cursor: default; border-color: var(--accent); }

.cp-item-remove {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: transparent;
  color: var(--muted);
  font-size: 11px;
  cursor: pointer;
}

.cp-item-remove:hover { color: var(--text); border-color: var(--muted); }

.cp-arrows {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
  color: var(--faint);
  flex-shrink: 0;
}

.cp-preview {
  margin-top: 10px;
  word-break: break-word;
}

@media (max-width: 620px) {
  .cp-picker { flex-direction: column; }
  .cp-arrows { flex-direction: row; justify-content: center; }
  .cp-box-body { min-height: 160px; }
}

/* ── status page ───────────────────────────────────────── */

.cp-status-panel { max-width: 720px; }

.cp-success {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding: 16px;
  margin-bottom: 22px;
  border: 1px solid var(--accent);
  border-radius: 14px;
  background: rgba(79, 209, 197, 0.08);
}

.cp-success-tick {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: var(--accent);
  color: #000;
  font-size: 15px;
  font-weight: 700;
}

.cp-success-title { margin: 0; font-size: 15px; color: var(--text); }
.cp-success-title strong { color: var(--accent); }

.cp-success-sub {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.6;
  color: var(--muted);
  word-break: break-word;
}

.cp-edit-note { margin-bottom: 18px; }

/* three per row, wrapping */
.cp-space-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.cp-space-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 9px;
  padding: 16px 12px;
  border: 1px solid var(--border);
  border-radius: 14px;
  background: var(--field);
  text-align: center;
}

.cp-space-image {
  position: relative;
  width: 76px;
  height: 76px;
  display: grid;
  place-items: center;
  border: 1px solid var(--border);
  border-radius: 999px;
  overflow: hidden;
  cursor: pointer;
  padding: 0;
}

.cp-space-image img { width: 100%; height: 100%; object-fit: cover; }

.cp-space-emoji { font-size: 30px; line-height: 1; }

.cp-space-image-edit {
  position: absolute;
  inset: auto 0 0 0;
  padding: 3px 0;
  font-size: 9px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fff;
  background: rgba(0, 0, 0, 0.72);
  opacity: 0;
  transition: opacity 0.18s ease;
}

.cp-space-image:hover .cp-space-image-edit,
.cp-space-image:focus-visible .cp-space-image-edit { opacity: 1; }

.cp-space-type {
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 600;
}

.cp-space-name {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 5px 10px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: var(--text);
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  word-break: break-word;
}

.cp-space-name:hover { border-color: var(--border); }

.cp-space-pencil { font-size: 10px; color: var(--faint); flex-shrink: 0; }

.cp-space-name-input {
  width: 100% !important;
  height: 36px !important;
  font-size: 13px !important;
  text-align: center;
}

.cp-space-warn { font-size: 10px; color: #f0a274; }

.cp-space-reset {
  border: none;
  background: transparent;
  color: var(--faint);
  font-size: 10px;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
}

.cp-space-reset:hover { color: var(--text); }

.cp-saved-note {
  margin: 16px 0 0;
  font-size: 12px;
  color: var(--accent);
  text-align: center;
}

.cp-status-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
}

.cp-status-submit { flex: 1 1; margin-top: 0 !important; }

@media (max-width: 620px) {
  .cp-space-grid { grid-template-columns: repeat(2, 1fr); }
  .cp-status-actions { flex-direction: column-reverse; }
  .cp-status-actions .pc-btn,
  .cp-status-submit { width: 100%; }
}

@media (max-width: 380px) {
  .cp-space-grid { grid-template-columns: 1fr; }
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/PublicLayout/CreateProfile/CreateProfile.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;;EAElC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,yFAAyF;AAC3F;;AAEA,6DAA6D;;AAE7D;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+BAA+B,oBAAoB,EAAE;;AAErD;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6DAA6D;;AAE7D;;;;;;EAME,WAAW;EACX,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA,wCAAwC,mBAAmB,EAAE;;AAE7D;kCACkC,2BAA2B,EAAE;;AAE/D;;EAEE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,wCAAwC,kBAAkB,EAAE;;AAE5D,6DAA6D;;AAE7D;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;EAEE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;AACrC;;AAEA,wBAAwB,2BAA2B,EAAE;;AAErD,kBAAkB,mBAAmB,EAAE,eAAe,EAAE;;AAExD,6DAA6D;;AAE7D;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mCAAmC;AACrC;;AAEA,+BAA+B,2BAA2B,EAAE;;AAE5D;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,6DAA6D;;AAE7D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,6DAA6D;;AAE7D,uBAAuB,oBAAoB,EAAE,qBAAqB,EAAE;AACpE,6BAA6B,0BAA0B,EAAE;;AAEzD;EACE,eAAe;EACf,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,6DAA6D;;AAE7D;EACE,qBAAqB,uBAAuB,EAAE;EAC9C,qBAAqB,aAAa,EAAE;EACpC,wBAAwB,eAAe,EAAE;EACzC;mBACiB,sBAAsB,EAAE,oBAAoB,EAAE;EAC/D,UAAU,WAAW,EAAE;AACzB;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,eAAe,oBAAoB,EAAE;;AAErC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA,wBAAwB,oBAAoB,EAAE,2BAA2B,EAAE;;AAE3E;EACE,SAAO;EACP,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,YAAY;EACZ,mCAAmC;AACrC;;AAEA,iBAAiB,2BAA2B,EAAE;;AAE9C;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6BAA6B,2BAA2B,EAAE;;AAE1D,oBAAoB,eAAe,EAAE,2BAA2B,EAAE;;AAElE;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA,wBAAwB,kBAAkB,EAAE,0BAA0B,EAAE;;AAExE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa,sBAAsB,EAAE;EACrC,aAAa,mBAAmB,EAAE,uBAAuB,EAAE;EAC3D,eAAe,iBAAiB,EAAE;AACpC;;AAEA,6DAA6D;;AAE7D,mBAAmB,gBAAgB,EAAE;;AAErC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB,SAAS,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACpE,2BAA2B,oBAAoB,EAAE;;AAEjD;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,gBAAgB,mBAAmB,EAAE;;AAErC,4BAA4B;AAC5B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA,sBAAsB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;;AAEpE,kBAAkB,eAAe,EAAE,cAAc,EAAE;;AAEnD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,+BAA+B;EAC/B,UAAU;EACV,8BAA8B;AAChC;;AAEA;qDACqD,UAAU,EAAE;;AAEjE;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,sBAAsB;AACxB;;AAEA,uBAAuB,2BAA2B,EAAE;;AAEpD,mBAAmB,eAAe,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAEzE;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,iBAAiB,eAAe,EAAE,cAAc,EAAE;;AAElD;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,UAAU;AACZ;;AAEA,wBAAwB,kBAAkB,EAAE;;AAE5C;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,oBAAoB,SAAO,EAAE,wBAAwB,EAAE;;AAEvD;EACE,iBAAiB,qCAAqC,EAAE;EACxD,qBAAqB,8BAA8B,EAAE;EACrD;sBACoB,WAAW,EAAE;AACnC;;AAEA;EACE,iBAAiB,0BAA0B,EAAE;AAC/C","sourcesContent":["/* CreateProfile.css */\n\n.cp-auth-container {\n  --bg: #000000;\n  --panel: #0a0a0a;\n  --border: darkslategray;\n  --text: #ffffff;\n  --muted: rgba(255, 255, 255, 0.55);\n  --faint: rgba(255, 255, 255, 0.35);\n  --accent: #4fd1c5;\n  --danger: #e06a6a;\n  --field: rgba(255, 255, 255, 0.04);\n\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 100vh;\n  padding: 40px 20px 64px;\n  background: var(--bg);\n  color: var(--text);\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n/* ── panel ─────────────────────────────────────────────── */\n\n.pc-form-container {\n  width: 100%;\n  max-width: 640px;\n  padding: 32px;\n  border: 1px solid var(--border);\n  border-radius: 20px;\n}\n\n.form-box-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 20px;\n  margin-bottom: 26px;\n}\n\n.pc-form-container h2 {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--text);\n  text-align: left;\n}\n\n.form-box-header .logo-default-container-img {\n  width: 46px;\n  height: 46px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n/* ── form layout ───────────────────────────────────────── */\n\n.pc-form-container form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* one row = one or more fields side by side */\n.pc-form-group-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 14px;\n  width: 100%;\n}\n\n.pc-form-group {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pc-form-group label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--muted);\n  text-align: left;\n}\n\n.pc-form-group label .pc-req { color: var(--accent); }\n\n.pc-hint {\n  font-size: 11px;\n  color: var(--faint);\n  line-height: 1.5;\n}\n\n/* ── fields ────────────────────────────────────────────── */\n\n.cp-auth-container input[type=\"text\"],\n.cp-auth-container input[type=\"tel\"],\n.cp-auth-container input[type=\"date\"],\n.cp-auth-container input[type=\"password\"],\n.cp-auth-container select,\n.cp-auth-container textarea {\n  width: 100%;\n  height: 46px;\n  padding: 0 14px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--field);\n  color: var(--text);\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.18s ease;\n}\n\n.cp-auth-container input::placeholder { color: var(--faint); }\n\n.cp-auth-container input:focus,\n.cp-auth-container select:focus { border-color: var(--accent); }\n\n.cp-auth-container input:disabled,\n.cp-auth-container input[readonly] {\n  color: var(--muted);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.cp-auth-container input[type=\"date\"] { color-scheme: dark; }\n\n/* ── checkbox rows ─────────────────────────────────────── */\n\n.pc-checkbox-container,\n.terms-conditions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 10px;\n}\n\n.pc-checkbox-container label,\n.terms-conditions label {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text);\n  cursor: pointer;\n}\n\n.cp-auth-container input[type=\"checkbox\"] {\n  width: 17px;\n  height: 17px;\n  flex-shrink: 0;\n  margin: 0;\n  accent-color: var(--accent);\n  cursor: pointer;\n}\n\n/* ── upload rows ───────────────────────────────────────── */\n\n.pc-upload-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n}\n\n.pc-profilepic,\n.pc-mediaupload {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  height: 46px;\n  padding: 0 6px 0 14px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--field);\n  box-sizing: border-box;\n}\n\n.pc-uploadimage,\n.pc-mediaupload input[type=\"text\"] {\n  flex: 1;\n  min-width: 0;\n  height: auto !important;\n  padding: 0 !important;\n  border: none !important;\n  background: transparent !important;\n  font-size: 14px;\n}\n\n.pc-imageupload {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  cursor: pointer;\n  transition: border-color 0.18s ease;\n}\n\n.pc-imageupload:hover { border-color: var(--accent); }\n\n.pc-upload-icon { color: var(--muted); font-size: 15px; }\n\n/* ── buttons ───────────────────────────────────────────── */\n\n.pc-btn {\n  height: 46px;\n  padding: 0 20px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  border: 1px solid var(--border);\n  background: rgb(34, 31, 31);\n  color: var(--text);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: border-color 0.18s ease;\n}\n\n.pc-btn:hover:not(:disabled) { border-color: var(--accent); }\n\n.pc-btn-accent {\n  border-color: var(--accent);\n  background: var(--accent);\n  color: #000;\n}\n\n.submit-btn {\n  width: 100%;\n  height: 50px;\n  margin-top: 6px;\n  border-radius: 10px;\n  border: 1px solid var(--accent);\n  background: var(--accent);\n  color: #000;\n  font-size: 15px;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  transition: opacity 0.18s ease;\n}\n\n.submit-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  background: rgb(34, 31, 31);\n  border-color: var(--border);\n  color: var(--muted);\n}\n\n/* ── messages ──────────────────────────────────────────── */\n\n.error-message {\n  margin: 0 0 18px;\n  padding: 11px 14px;\n  border: 1px solid rgba(224, 106, 106, 0.4);\n  border-radius: 10px;\n  background: rgba(224, 106, 106, 0.08);\n  color: var(--danger);\n  font-size: 13px;\n  text-align: left;\n}\n\n/* ── links + footer ────────────────────────────────────── */\n\n.cp-auth-container a { color: var(--accent); text-decoration: none; }\n.cp-auth-container a:hover { text-decoration: underline; }\n\n.copyright-container {\n  margin-top: 8px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border);\n}\n\n.copyright {\n  margin: 0;\n  font-size: 11px;\n  line-height: 1.6;\n  color: var(--faint);\n  text-align: center;\n}\n\n/* ── responsive ────────────────────────────────────────── */\n\n@media (max-width: 620px) {\n  .cp-auth-container { padding: 22px 14px 48px; }\n  .pc-form-container { padding: 22px; }\n  .pc-form-container h2 { font-size: 21px; }\n  .pc-form-group-row,\n  .pc-upload-row { flex-direction: column; align-items: stretch; }\n  .pc-btn { width: 100%; }\n}\n\n/* ── two-box picker ────────────────────────────────────── */\n\n.cp-picker {\n  display: flex;\n  align-items: stretch;\n  gap: 12px;\n}\n\n.cp-box {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: var(--field);\n  overflow: hidden;\n}\n\n.cp-box-drop { border-style: dashed; }\n\n.cp-box-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--border);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.cp-box-head h4 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.cp-box-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--muted);\n  padding: 2px 9px;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n}\n\n.cp-box-count.is-full { color: var(--accent); border-color: var(--accent); }\n\n.cp-box-body {\n  flex: 1;\n  min-height: 230px;\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.cp-box-empty {\n  margin: auto;\n  font-size: 12px;\n  color: var(--faint);\n  text-align: center;\n}\n\n.cp-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: 9px;\n  background: rgb(34, 31, 31);\n  color: var(--text);\n  font-size: 13px;\n  text-transform: capitalize;\n  cursor: grab;\n  transition: border-color 0.16s ease;\n}\n\n.cp-item:hover { border-color: var(--accent); }\n\n.cp-item.is-disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.cp-item.is-disabled:hover { border-color: var(--border); }\n\n.cp-item-selected { cursor: default; border-color: var(--accent); }\n\n.cp-item-remove {\n  width: 22px;\n  height: 22px;\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  border: 1px solid var(--border);\n  background: transparent;\n  color: var(--muted);\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.cp-item-remove:hover { color: var(--text); border-color: var(--muted); }\n\n.cp-arrows {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n  font-size: 16px;\n  color: var(--faint);\n  flex-shrink: 0;\n}\n\n.cp-preview {\n  margin-top: 10px;\n  word-break: break-word;\n}\n\n@media (max-width: 620px) {\n  .cp-picker { flex-direction: column; }\n  .cp-arrows { flex-direction: row; justify-content: center; }\n  .cp-box-body { min-height: 160px; }\n}\n\n/* ── status page ───────────────────────────────────────── */\n\n.cp-status-panel { max-width: 720px; }\n\n.cp-success {\n  display: flex;\n  align-items: flex-start;\n  gap: 13px;\n  padding: 16px;\n  margin-bottom: 22px;\n  border: 1px solid var(--accent);\n  border-radius: 14px;\n  background: rgba(79, 209, 197, 0.08);\n}\n\n.cp-success-tick {\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  background: var(--accent);\n  color: #000;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.cp-success-title { margin: 0; font-size: 15px; color: var(--text); }\n.cp-success-title strong { color: var(--accent); }\n\n.cp-success-sub {\n  margin: 6px 0 0;\n  font-size: 12px;\n  line-height: 1.6;\n  color: var(--muted);\n  word-break: break-word;\n}\n\n.cp-edit-note { margin-bottom: 18px; }\n\n/* three per row, wrapping */\n.cp-space-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n}\n\n.cp-space-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 9px;\n  padding: 16px 12px;\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  background: var(--field);\n  text-align: center;\n}\n\n.cp-space-image {\n  position: relative;\n  width: 76px;\n  height: 76px;\n  display: grid;\n  place-items: center;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  overflow: hidden;\n  cursor: pointer;\n  padding: 0;\n}\n\n.cp-space-image img { width: 100%; height: 100%; object-fit: cover; }\n\n.cp-space-emoji { font-size: 30px; line-height: 1; }\n\n.cp-space-image-edit {\n  position: absolute;\n  inset: auto 0 0 0;\n  padding: 3px 0;\n  font-size: 9px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.72);\n  opacity: 0;\n  transition: opacity 0.18s ease;\n}\n\n.cp-space-image:hover .cp-space-image-edit,\n.cp-space-image:focus-visible .cp-space-image-edit { opacity: 1; }\n\n.cp-space-type {\n  font-size: 10px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.cp-space-name {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 100%;\n  padding: 5px 10px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text);\n  font-size: 13px;\n  font-family: inherit;\n  cursor: pointer;\n  word-break: break-word;\n}\n\n.cp-space-name:hover { border-color: var(--border); }\n\n.cp-space-pencil { font-size: 10px; color: var(--faint); flex-shrink: 0; }\n\n.cp-space-name-input {\n  width: 100% !important;\n  height: 36px !important;\n  font-size: 13px !important;\n  text-align: center;\n}\n\n.cp-space-warn { font-size: 10px; color: #f0a274; }\n\n.cp-space-reset {\n  border: none;\n  background: transparent;\n  color: var(--faint);\n  font-size: 10px;\n  text-decoration: underline;\n  cursor: pointer;\n  padding: 0;\n}\n\n.cp-space-reset:hover { color: var(--text); }\n\n.cp-saved-note {\n  margin: 16px 0 0;\n  font-size: 12px;\n  color: var(--accent);\n  text-align: center;\n}\n\n.cp-status-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.cp-status-submit { flex: 1; margin-top: 0 !important; }\n\n@media (max-width: 620px) {\n  .cp-space-grid { grid-template-columns: repeat(2, 1fr); }\n  .cp-status-actions { flex-direction: column-reverse; }\n  .cp-status-actions .pc-btn,\n  .cp-status-submit { width: 100%; }\n}\n\n@media (max-width: 380px) {\n  .cp-space-grid { grid-template-columns: 1fr; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
